import React from "react";
import { BrowserRouter } from 'react-router-dom'
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { initOfflineHandler } from './services/offline-handler';


// Initialize offline handler
initOfflineHandler();
 
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
<>
    <App />
    <ToastContainer />
  </>
  );
